import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import React from 'react'

import Badge from '../../../components/badge'
import SettingsCard from '../../../components/Settings/SettingsCard'
import SettingsLayout from '../../../components/Settings/SettingsLayout'
import CharitySearchList from './list'
import UserCharitiesList from '../userCharitiesList'

export default function CharitiesIndexPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const breadcrumbs = [
    { label: t('navigation_banner.home'), to: '/' },
    { label: t('charities.myCharities.title') },
  ]

  return (
    <SettingsLayout
      title={
        <>
          {t('charities.myCharities.title')}
          <Badge />
        </>
      }
      breadcrumbs={breadcrumbs}
    >
      <SettingsCard
        icon="search"
        title={t('charities.search.search_button')}
        description={t('charities.search.message')}
      >
        <CharitySearchList initialQuery={searchParams.get('search')} />
      </SettingsCard>
      <SettingsCard icon="hands-heart" title={t('charities.myCharities.title')}>
        <UserCharitiesList />
      </SettingsCard>
    </SettingsLayout>
  )
}
